import { TeamInsuranceProductClient } from 'clients';
import { QueryKeys } from 'enums';
import { TeamInsuranceProduct } from 'types';
import { UseQueryBaseSearchOptions } from './query/types';
import { useMutate } from './query/useMutate';
import { useQuerySearch } from './query/useQuery';

export function useSearchTeamInsuranceProduct(props?: UseQueryBaseSearchOptions<TeamInsuranceProduct>) {
  const { filter, queryOptions, enabled } = props || {};
  return useQuerySearch({
    queryKey: QueryKeys.TeamInsuranceProduct,
    clientClass: TeamInsuranceProductClient,
    enabled,
    filter,
    queryOptions: {
      ...queryOptions,
      // 2 hours cache time as this is not a frequently changing data
      staleTime: 2 * 60 * 60 * 1000,
    },
  });
}

export function useMutateTeamInsuranceProduct() {
  const { update: updateTeamInsuranceProduct } = useMutate<
    TeamInsuranceProduct,
    TeamInsuranceProduct,
    TeamInsuranceProduct,
    TeamInsuranceProductClient
  >({
    queryKey: QueryKeys.TeamInsuranceProduct,
    clientClass: TeamInsuranceProductClient,
    createOptions: {
      throwOnError: true,
    },
    updateOptions: { throwOnError: true },
  });

  return { updateTeamInsuranceProduct };
}
